const MAKEUP_CATEGORIES = {
  EYES: 'Eyes/Brows',
  LIPS: 'Lips',
  FACE: 'Cheeks/Face',
  NAILS: 'Nails',
  ACCESSORY: 'Accessory/Other',
};

export default MAKEUP_CATEGORIES;
